module.exports = __webpack_public_path__ + "resources/img/bg_cover_intro_m_v2.450c093918825525fd1102fcd8ef5775.png";